// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2919": "e7cc14d5","4060": "101b48f1","8614": "3b89b684",}[chunkId] + ".css"
}